import clsx from 'clsx'
import { forwardRef, useState } from 'react'

import { ChevronDownSVGIcon } from '@/shared/assets'
import './DatePickerWithIcon.scss'

interface CustomDatePickerInputProps {
    value?: string
    onClick?: () => void
    isBlueBorder?: boolean
    className?: string
    error?: boolean
}

export const CustomDatePickerInput = forwardRef<
    HTMLInputElement,
    CustomDatePickerInputProps
>((props, ref) => {
    const { value, onClick, isBlueBorder, className, error } = props
    const [isOpen, setIsOpen] = useState(false)

    const handleClick = () => {
        setIsOpen((prevState) => !prevState)

        if (!isOpen && onClick) {
            onClick()
        }
    }

    return (
        <div
            className={clsx(
                'date-picker-custom-wrapper relative inline-block',
                {
                    'date-picker-custom-wrapper--blue': isBlueBorder,
                    'date-picker-custom-wrapper--error': !!error,
                },
                className
            )}
            onClick={handleClick}
        >
            <input
                ref={ref}
                value={value || ''}
                readOnly
                className="date-picker-custom-input"
            />

            <div>
                <ChevronDownSVGIcon
                    className="date-picker-custom-icon"
                    width="18px"
                    height="18px"
                />
            </div>
        </div>
    )
})

CustomDatePickerInput.displayName = 'CustomDatePickerInput'
